var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowTop = function SvgArrowTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.307 9.375a1.16 1.16 0 0 1 0-1.619l6.899-6.483a1.107 1.107 0 0 1 1.587 0l6.899 6.484a1.16 1.16 0 0 1 0 1.618 1.107 1.107 0 0 1-1.587 0l-4.984-4.53v13.282c0 .632-.502 1.144-1.122 1.144-.62 0-1.122-.512-1.122-1.144V4.844l-4.983 4.53a1.107 1.107 0 0 1-1.587 0Z",
    fill: "currentColor"
  })));
};
export default SvgArrowTop;